<template>
  <div class="main-content">
    <div class="hui">
      <a
        href="#zsss"
        :class="getDetailActive == 1 ? 'getDetail' : 'getdetail'"
        @click="getDetailActive = 1"
        >招商详情</a
      >

      <a
        href="#zspi"
        :class="getDetailActive == 2 ? 'getDetail' : 'getdetail'"
        @click="getDetailActive = 2"
        >招商图片</a
      >
    </div>
    <div class="xiangqing">
      <div class="footerTitle" id="zsss"></div>
      <div class="fengexian">
        <el-divider>招商详情</el-divider>
      </div>
      <p v-html="jiekoudata.detail"></p>
    </div>
    <div class="xiangqing">
      <div class="footerTitle" id="zspi"></div>
      <div class="fengexian">
        <el-divider>招商图片</el-divider>
      </div>

      <div class="imgcontent">
        <el-image
          v-for="(item, index) in jiekoudata.imgList"
          :key="index"
          style="
            width: 48%;
            height: auto;
            margin-left: 10px;
            margin-bottom: 10px;
          "
          :src="item"
          :preview-src-list="jiekoudata.imgList"
        >
        </el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    jiekoudata: {
      type: Object,
      default: {}
    },
  },
  data () {
    return {
      getDetailActive: 1,
    }
  },
}
</script>
<style>
.el-divider__text {
  font-size: 36px;
  /* margin-bottom: 40px; */
  color: #ec222f;
  list-style: armenian;
}
</style>
<style lang="scss" scoped>
.hui {
  height: 90px;
  background-color: #f1f1f1;
  display: flex;
  font-size: 30px;
  border-radius: 10px;
}

.hui > div {
  line-height: 90px;
  width: 200px;
  cursor: pointer;
  /* background-color: #fff; */
}
.getdetail {
  /* font-size: 24px; */
  padding: 0 30px;
  font-weight: 600;
  line-height: 90px;
  opacity: 0.5;
  /* border: 1px solid red; */
}

.getDetail {
  /* font-size: 24px; */
  padding: 0 30px;
  line-height: 90px;
  border-bottom: 5px solid #6681ea;
  background-color: white;
}
.xiangqing {
  margin-top: 20px;
}

.footerTitle {
  font-size: 36px;
  height: 15px;
  /* border: #67C23A 1px solid; */
  /* margin-bottom: 40px; */
  color: #ec222f;
  /* list-style: armenian; */
}

.fengexian {
  margin-bottom: 50px;
}
.imgcontent {
  display: flex;
  /* justify-content: s; */
  flex-wrap: wrap;
}
</style>